import { style } from 'typestyle'
export const pl0 = style({ paddingLeft: '0px' })
